import { WORDPRESS_API } from "shared/constants/api";


export const mLegitymacjaDocuments = [
  {
    id: "zarzadzenie-18-2025",
    title: "Zarządzenie Nr 18/2025",
    href: `${WORDPRESS_API}/wp-content/uploads/2026/06/SC227-CKZIU26061811440.pdf`
  },
  {
    id: "mlegitymacja",
    title: "mLegitymacja",
    href: `${WORDPRESS_API}/wp-content/uploads/2019/03/mLegitymacja.pdf`
  },
  {
    id: "ulotka-informacyjna",
    title: "Ulotka informacyjna",
    href: `${WORDPRESS_API}/wp-content/uploads/2019/03/ulotka_informacyjna_mObywatel_Junior.pdf`
  },
  {
    id: "prezentacja",
    title: "Prezentacja",
    href: `${WORDPRESS_API}/wp-content/uploads/2019/03/Prezentacja_mObywatel_-_Junior.pdf`
  }
];